import { useEffect, useState } from "react";
import { NotificationCategory } from "../../Constants/Enums/Notification.enum";
import { useGetUsersNotifications } from "../../hooks/notifications/notifications.hooks";
import { getValue } from "../../utils/object.utils";
import { Notification } from "./Notification";

import { useSocketListener } from "../../hooks/socketHooks/socket.hooks";
import { SocketEventEnum } from "../../Constants/Enums/Socket.enum";
import moment from "moment";

export const NotificationLists = () => {
  const { isLoading: isNotificationsLoading, data: notificationsLists } =
    useGetUsersNotifications();

  const [allNotifications, setAllNotifications] = useState<any[]>([]);

  useEffect(() => {
    if (!isNotificationsLoading) {
      setAllNotifications(notificationsLists || []);
    }
  }, [isNotificationsLoading, notificationsLists]);

  const handleNotification = (notification: any) => {
    setAllNotifications((prevNotifications) => [
      notification?.notificationDetails || {},
      ...(prevNotifications || []),
    ]);
  };

  useSocketListener({
    eventName: SocketEventEnum.APP_NOTIFICATION,
    handlerFunction: (notification) => {
      handleNotification(notification);
    },
  });

  if (isNotificationsLoading) {
    return <></>;
  }

  return (
    <div
      style={{
        maxHeight: "600px",
        overflowY: "scroll",
      }}
      className="no-scrollbar"
    >
      {(allNotifications || []).map((notification: any, index: number) => {
        const title = getValue(notification, "title", "");
        const text = getValue(notification, "text", "");
        const category = getValue(
          notification,
          "category",
          NotificationCategory.GENERAL
        );
        const isSeen = getValue(notification, "is_seen", false);
        const createdAt = getValue(notification, "created_at", "");
        const createdAgo = moment(createdAt).fromNow();

        return (
          <div key={index}>
            <Notification
              title={title}
              text={text}
              category={category}
              isSeen={isSeen}
              createdAgo={createdAgo}
            />
          </div>
        );
      })}
    </div>
  );
};
